import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import moment from "moment";
import { leadEstimateInitial } from "./leadUtils";
import { mapKeys } from "lodash";

export const initialSummaryLocalState = {
  removalDate: null,
  removalEndDate: null,
  movingFrom: [
    {
      building_number: null,
      street: null,
      town: null,
      county: null,
      postcode: null,
      country: null,
      purchaseStatus: "",
      paces: "",
      flightOfStairs: 0,
      bedrooms: 0,
      floors: 0,
      liftAvailability: null,
      type: null,
      isPostcodeVerified: false,
    },
  ],
  movingTo: [
    {
      building_number: null,
      street: null,
      town: null,
      county: null,
      postcode: null,
      country: null,
      purchaseStatus: "",
      paces: "",
      flightOfStairs: 0,
      bedrooms: 0,
      floors: 0,
      liftAvailability: null,
      type: null,
      isPostcodeVerified: false,
    },
  ],
  customerId: null,
  customerName: null,
  customerCountryCode: "+44",
  customerPhone: null,
  customerAlternateCountryCode: "+44",
  customerAlternatePhone: null,
  customerEmail: null,
  photos: [],
  access:null,
  notes: null,
  contentValue: null,
  summaryStatus: null,
  services: [
    {
      serviceName: "fullPack",
      typeName: "Full Pack",
      isAccepted: false,
    },

    {
      serviceName: "removal",
      typeName: "Removal",
      isAccepted: true,
    },

    {
      serviceName: "intostore",
      typeName: "Into Store",
      isAccepted: false,
    },

    {
      serviceName: "outofstore",
      typeName: "Out Of Store",
      isAccepted: false,
    },

    {
      serviceName: "clearance",
      typeName: "Clearance",
      isAccepted: false,
    },
    {
      serviceName: "unpack",
      typeName: "Unpack",
      isAccepted: false,
    },
    {
      serviceName: "dismantle",
      typeName: "Dismantle",
      isAccepted: false,
    },
    {
      serviceName: "fragilepack",
      typeName: "Fragile Pack",
      isAccepted: false,
    },
    {
      serviceName: "vehicleHire",
      typeName: "Vehicle Hire",
      isAccepted: false,
    },
    {
      serviceName: "exportPack",
      typeName: "Export Pack",
      isAccepted: false,
    },
    {
      serviceName: "storage",
      typeName: "Storage",
      isAccepted: false,
    },
  ],
  requirements: [
    {
      serviceName: "insurance",
      typeName: "Insurance",
      isAccepted: false,
    },
    {
      serviceName: "material",
      typeName: "Material",
      isAccepted: false,
    },
    // {
    //   serviceName: "fragile",
    //   typeName:'Fragile',
    //   isAccepted: false,
    // },
  ],
};

const initialState = {
  newSurveySummary: initialSummaryLocalState,
  surveyRoomList: null,
  propertyTypeList: null,
  surveyedItems: null,
  surveyedSummary: null,
  isSurveyTabSuccess: false,
  isSurveySummarySuccess: false,
  isCompleteSurveyedSummarySuccess: false,
  linkedItems: null,
  isGetSurveyedItems: false,
  isCanceledSurvey: false,
  isSurveyTooltips: false,
};

const leadSurveySlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    getAllRoomListAction: (state, { payload }) => {},
    setAllRoomListAction: (state, { payload }) => {
      state.surveyRoomList = payload;
    },

    setPropertyTypeAction: (state, { payload }) => {
      state.propertyTypeList = payload;
    },

    updateSurveyTabAction: (state, { payload }) => {},
    setUpdateSurveyTabAction: (state, { payload }) => {
      state.isSurveyTabSuccess = payload;
    },

    getAllSurveyedItemsAction: (state, { payload }) => {},
    setAllSurveyedItemsAction: (state, { payload }) => {
      state.surveyedItems = payload;
    },

    getAllLinkedItemsAction: (state) => {},
    setAllLinkedItemsAction: (state, { payload }) => {
      state.linkedItems = payload;
    },

    getAllSurveyedSummaryAction: (state, { payload }) => {},
    setAllSurveyedSummaryAction: (state, { payload }) => {
      state.surveyedSummary = payload;
    },

    setNewSurveySummaryLocal: (state, action) => {
      state.newSurveySummary = {
        ...state.newSurveySummary,
        ...action.payload,
      };
    },

    resetNewSurveySummaryLocal: (state) => {
      state.newSurveySummary = initialSummaryLocalState;
    },

    updateSurveySummaryAction: (state, { payload }) => {},
    setUpdateSurveySummaryAction: (state, { payload }) => {
      state.isSurveySummarySuccess = payload;
    },

    startSurveyAction: (state, { payload }) => {},
    setstartSurveyAction: (state, { payload }) => {
      // state.isSurveyStarted = payload
    },

    getCompleteSurveySummaryAction: (state, { payload }) => {},
    setCompleteSurveySummaryAction: (state, { payload }) => {
      state.isCompleteSurveyedSummarySuccess = payload;
    },
    setIsGetSurveyedItemsAction: (state, { payload }) => {
      state.isGetSurveyedItems = payload;
    },

    cancelSurveyAction: (state, { payload }) => {},
    setCancelSurveyAction: (state, { payload }) => {
      state.isCanceledSurvey = payload;
    },

    updateSurveyTooltipAction: (state, { payload }) => {},
    setSurveyTooltipsAction: (state, { payload }) => {
      state.isSurveyTooltips = payload;
    },
  },
});

const {
  getAllRoomListAction,
  setAllRoomListAction,
  setPropertyTypeAction,
  updateSurveyTabAction,
  getAllSurveyedItemsAction,
  setAllSurveyedItemsAction,
  setUpdateSurveyTabAction,
  getAllLinkedItemsAction,
  setAllLinkedItemsAction,
  startSurveyAction,
  setstartSurveyAction,
  getAllSurveyedSummaryAction,
  setAllSurveyedSummaryAction,
  setNewSurveySummaryLocal,
  resetNewSurveySummaryLocal,
  updateSurveySummaryAction,
  setUpdateSurveySummaryAction,
  getCompleteSurveySummaryAction,
  setCompleteSurveySummaryAction,
  setIsGetSurveyedItemsAction,
  cancelSurveyAction,
  setCancelSurveyAction,
  updateSurveyTooltipAction,
  setSurveyTooltipsAction,
} = leadSurveySlice.actions;
export {
  getAllRoomListAction,
  setAllRoomListAction,
  setPropertyTypeAction,
  updateSurveyTabAction,
  getAllSurveyedItemsAction,
  setAllSurveyedItemsAction,
  setUpdateSurveyTabAction,
  getAllLinkedItemsAction,
  setAllLinkedItemsAction,
  startSurveyAction,
  setstartSurveyAction,
  getAllSurveyedSummaryAction,
  setAllSurveyedSummaryAction,
  setNewSurveySummaryLocal,
  resetNewSurveySummaryLocal,
  updateSurveySummaryAction,
  setUpdateSurveySummaryAction,
  getCompleteSurveySummaryAction,
  setCompleteSurveySummaryAction,
  setIsGetSurveyedItemsAction,
  cancelSurveyAction,
  setCancelSurveyAction,
  updateSurveyTooltipAction,
  setSurveyTooltipsAction,
};

export default leadSurveySlice.reducer;
